import { sassmallRequest } from "./client";
import { filterGoodsListResponse } from "../../utils/trafficItemFilter.js";

function normalizeSassmallTbLanguage(language?: string) {
  const languageKey = String(language || "").trim().replace(/_/g, "-").toLowerCase();
  const languageMap: Record<string, string> = {
    en: "en",
    "en-us": "en",
    vi: "vi",
    "vi-vn": "vi",
    ja: "ja",
    "ja-jp": "ja",
    jp: "ja",
  };
  return languageMap[languageKey] || "";
}

export function getSassmallTbGoodsDetail(itemId: string, language?: string) {
  const supportedLanguage = normalizeSassmallTbLanguage(language);
  return sassmallRequest<Record<string, any>>("/overSeasTaoBao/traffic-item-get", {
    method: "POST",
    body: { itemId, itemResource: "taobao", ...(supportedLanguage ? { language: supportedLanguage } : {}) },
  });
}

export function getSassmallAlibabaGoodsDetail(offerId: string, country = "en") {
  return sassmallRequest<Record<string, any>>("/alibabaGoods/productSearchQueryProductDetail", {
    method: "POST",
    body: { offerId, country },
  });
}

export function getSassmallAlibabaCategoryTranslation(payload: Record<string, any>) {
  const request = payload.param || payload;
  return sassmallRequest<Record<string, any>>("/alibabaGoods/categoryTranslationGetById", {
    method: "POST",
    body: { ...request, language: request.language || request.country || "en" },
  });
}

export function getSassmallWeidianGoodsDetail(offerId: string) {
  return sassmallRequest<Record<string, any>>("/weidian/buyer/itemDetail", {
    method: "POST",
    body: { offerId, commentPageSize: 20 },
  });
}

export function searchSassmallTbGoods(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>("/overSeasTaoBao/traffic-item-search", {
    method: "POST",
    body: payload,
  }).then(response => filterGoodsListResponse(response));
}

export function searchSassmallAlibabaGoods(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>("/alibabaGoods/productSearchKeywordQuery", {
    method: "POST",
    body: payload,
  }).then(response => filterGoodsListResponse(response));
}

export function searchSassmallAlibabaStoreGoods(payload: Record<string, any>) {
  const request = payload.param || payload;
  return sassmallRequest<Record<string, any>>("/alibabaGoods/productSearchQuerySellerOfferList", {
    method: "POST",
    body: {
      ...request,
      beginPage: request.beginPage || request.pageNo || 1,
      sellerOpenId: request.sellerOpenId || request.shopId,
    },
  }).then(response => filterGoodsListResponse(response));
}

export function searchSassmallWeidianGoods(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>("/weidian/buyer/itemSearchKeyword", {
    method: "POST",
    body: payload,
  }).then(response => filterGoodsListResponse(response));
}

export function searchSassmallWeidianGoodsByImage(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>[]>("/weidian/buyer/itemSearchImage", {
    method: "POST",
    body: payload,
  }).then(response => filterGoodsListResponse(response));
}
